import { useState } from "react";
import Modal from "react-modal";
import CloudUpload from "../../../../../assets/images/commonIcons/CloudUpload.svg";
import trashIcons from "../../../../../assets/images/commonIcons/Trash.svg";
import VerticalDots from "../../../../../assets/images/commonIcons/VerticalThreeDots.svg";
import { AddOthersDocuments } from "./AddOthersDocument";
import { SITE_URL } from "../../../../../constants/apiUrls";

export const OthersComponent = () => {
  const OthersDocs = [
    {
      title: "Audited Financial Statement",
      imageUrl: `${SITE_URL}/static/media/working-relation.322c2008b663705a8884.png`,
      lastUpdated: "2 days ago",
    },
    {
      title: "Audited Financial Statement 1",
      imageUrl: `${SITE_URL}/static/media/working-relation.322c2008b663705a8884.png`,
      lastUpdated: "3 days ago",
    },
  ];

  const [isOpen, setIsOpen] = useState(false);

  const openModal = () => {
    setIsOpen(true);
  };

  const closeModal = () => {
    setIsOpen(false);
  };

  const OthersUploadDelete = () => {
    openModal();
  };

  return (
    <div className="p-2">
      <h2 className="text-left font-semibold py-4">Others</h2>

      <div className="sm:grid sm:grid-cols-3 gap-4">
        {false && <AddOthersDocuments />}

        {OthersDocs.map((OthersDoc) => (
          <div className="bg-white col-span-1 rounded-lg shadow-lg my-2">
            <div className="grid grid-cols-9 ">
              <div className="col-span-2 sm:col-span-9 sm:border">
                <div className="sm:mx-6 sm:mt-6 sm:border rounded-lg">
                  <img
                    src={OthersDoc.imageUrl}
                    className="w-full  h-20 sm:h-48 object-cover rounded-t-lg"
                    alt="document"
                  />
                </div>
              </div>
              <div className="col-span-6 sm:col-span-8 my-auto text-left sm:py-4 sm:pl-2 ">
                <h2 className="text-[12px] md:text-lg font-bold mb-2">
                  {OthersDoc.title}
                </h2>
                <p className="text-[12px] md:text-lg">
                  Last Updated: <span>{OthersDoc.lastUpdated}</span>
                </p>
              </div>
              <div className="my-auto sm:col-span-1 sm:py-4 sm:pr-2">
                <button onClick={OthersUploadDelete}>
                  <img src={VerticalDots} alt="VerticalDots" />
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>

      <Modal
        isOpen={isOpen}
        onRequestClose={closeModal}
        contentLabel="Upload Delete Confirmation"
        className="modal"
        overlayClassName="overlay"
      >
        <div className="w-[220px] sm:w-[250px]">
          <div className="w-full pb-2 text-end">
            <button onClick={closeModal}>&#9587;</button>
          </div>
          <div className="">
            <div className="pt-4">
              <button className="flex">
                <img src={CloudUpload} alt="CloudUploadIcon" />
                <h3 className="text-[#3C4848] pl-2">Re - Upload Document</h3>
              </button>
            </div>

            <div className="pt-4">
              <button className="flex">
                <img src={trashIcons} alt="trashIcon" />
                <h3 className="text-[red] pl-2">Delete</h3>
              </button>
            </div>
          </div>
        </div>
      </Modal>
    </div>
  );
};
